import {
    apiRequest,
    agamaCreate
} from "../../../../../services/adapters/kepegawaian/agamaService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", agamaCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository